// useStackedPersistentState.js
import {useCallback, useEffect, useState} from 'react';

const getInitialStackedState = () => {
  try {
    const saved = localStorage.getItem("stackedViewState");
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        expandedWorkspaces: parsed.expandedWorkspaces || {},
        expandedProjects: parsed.expandedProjects || {},
        expandedTasks: parsed.expandedTasks || {},
        expandedStacks: parsed.expandedStacks || {},        // NEW
        activeTabByJob: parsed.activeTabByJob || {},
        assigneeFilters: parsed.assigneeFilters || {},
      };
    }
  } catch (e) {
    console.error("Failed to load stacked view state", e);
  }
  return {
    expandedWorkspaces: {},
    expandedProjects: {},
    expandedTasks: {},
    expandedStacks: {},        // NEW
    activeTabByJob: {},
    assigneeFilters: {},
  };
};

export const useStackedPersistentState = () => {
  const [stackedState, setStackedState] = useState(getInitialStackedState);

  useEffect(() => {
    try {
      localStorage.setItem("stackedViewState", JSON.stringify(stackedState));
    } catch (e) {
      console.error("Failed to save stacked view state", e);
    }
  }, [stackedState]);

  const setExpandedWorkspaces = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      expandedWorkspaces: typeof valueOrUpdater === "function"
        ? valueOrUpdater(prev.expandedWorkspaces)
        : valueOrUpdater,
    }));
  }, []);

  const setExpandedProjects = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      expandedProjects: typeof valueOrUpdater === "function"
        ? valueOrUpdater(prev.expandedProjects)
        : valueOrUpdater,
    }));
  }, []);

  const setExpandedTasks = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      expandedTasks: typeof valueOrUpdater === "function"
        ? valueOrUpdater(prev.expandedTasks)
        : valueOrUpdater,
    }));
  }, []);

  // NEW setter for expandedStacks
  const setExpandedStacks = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      expandedStacks: typeof valueOrUpdater === "function"
        ? valueOrUpdater(prev.expandedStacks)
        : valueOrUpdater,
    }));
  }, []);

  const setActiveTabByJob = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      activeTabByJob: typeof valueOrUpdater === "function"
        ? valueOrUpdater(prev.activeTabByJob)
        : valueOrUpdater,
    }));
  }, []);

  const setAssigneeFilters = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      assigneeFilters: typeof valueOrUpdater === "function"
        ? valueOrUpdater(prev.assigneeFilters)
        : valueOrUpdater,
    }));
  }, []);

  return {
    stackedState,
    setStackedState,
    setExpandedWorkspaces,
    setExpandedProjects,
    setExpandedTasks,
    setExpandedStacks,      
    setActiveTabByJob,
    setAssigneeFilters,
  };
};